import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(
    private http: HttpClient
  ) { }

  headers = new HttpHeaders({
   'Content-Type': 'application/json',
  });
  httpGet(url: string, params?: any): Observable<any> {
    return this.http.get(url, {
      params,
      // headers: this.headers
    });
  }

  httpPost(url: string, body?: any, params?: any): Observable<any> {
    return this.http.post(url, body, {
      params,
      // headers: this.headers
    });
  }

  httpDelete(url: string, params?: any): Observable<any> {
    return this.http.delete(url, {
      params,
      // headers: this.headers
    });
  }

  httpUpdate(url: string, body?: any, params?: any): Observable<any> {
    return this.http.put(url, body, {
      params,
      headers: this.headers
    });
  }

  /**
   * 根据id获取单条数据详情
   * @param id 单条数据id
   * @param url 获取单条数据的接口地址
   */
  httpGetText(url: string, params?: any) {
    return this.http.get(url, {
      responseType: 'text',
      params
    }).pipe(
      map(res => res.replace(/\:([\-]?\d+(\.\d+)?)([\}\,])/g, '\:"$1"$3')),
      map(res => JSON.parse(res)),
      map(res => {
        res.code = Number(res.code);
        res.httpCode = Number(res.httpCode);
        return res;
      })
    );
  }

  httpPostText(url: string, body?: any, params?: any) {
    return this.http.post(url, body, {
      responseType: 'text',
      params
    }).pipe(
      map(res => res.replace(/\:([\-]?\d+(\.\d+)?)([\}\,])/g, '\:"$1"$3')),
      map(res => JSON.parse(res)),
      map(res => {
        res.code = Number(res.code);
        res.httpCode = Number(res.httpCode);
        return res;
      })
    );
  }

  httpPutText(url: string, body?: any, params?: any): Observable<any> {
    return this.http.put(url, body, {
      responseType: 'text',
      params
    }).pipe(
      map(res => res.replace(/\:([\-]?\d+(\.\d+)?)([\}\,])/g, '\:"$1"$3')),
      map(res => JSON.parse(res)),
      map(res => {
        res.code = Number(res.code);
        res.httpCode = Number(res.httpCode);
        return res;
      })
    );
  }
}
